import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    OnChanges,
    OnInit,
} from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BazisInputDateComponent } from '@bazis/form/components/datetime/input-date.component';
import moment from 'moment';
import { map, startWith } from 'rxjs/operators';
import { shareReplay } from 'rxjs';
import { SHARE_REPLAY_SETTINGS } from '@bazis/configuration.service';

@UntilDestroy()
@Component({
    selector: 'bazis-menu-input-date',
    templateUrl: './menu-input-date.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BazisMenuInputDateComponent
    extends BazisInputDateComponent
    implements AfterViewInit, OnChanges, OnInit
{
    todayDate = moment();

    tomorrowDate = moment().add(1, 'day');

    yesterdayDate = moment().subtract(1, 'day');

    today;

    tomorrow;

    yesterday;

    buttonStatus$;

    ngOnInit() {
        super.ngOnInit();

        this.today = this.todayDate.format(this.displayFormat);
        this.tomorrow = this.tomorrowDate.format(this.displayFormat);
        this.yesterday = this.yesterdayDate.format(this.displayFormat);

        this.buttonStatus$ = this.dateValue.valueChanges.pipe(
            startWith(this.dateValue.value),
            map((value) => {
                return {
                    nextEnabled:
                        !this.maxDate ||
                        moment(value, this.displayFormat).isBefore(
                            moment(this.maxDate, 'YYYY-MM-DD'),
                            'day',
                        ),
                    prevEnabled:
                        !this.minDate ||
                        moment(value, this.displayFormat).isAfter(
                            moment(this.minDate, 'YYYY-MM-DD'),
                            'day',
                        ),
                };
            }),
            shareReplay(SHARE_REPLAY_SETTINGS),
        );
    }

    changeDate(diff = 1) {
        if (!this.dateValue.value) {
            this.dateValue.setValue(this.today);
            return;
        }
        let currentDate = moment(this.dateValue.value, this.displayFormat);
        currentDate = currentDate.add(diff, 'day');
        this.dateValue.setValue(currentDate.format(this.displayFormat));
    }
}
